import { render, staticRenderFns } from "./PaymentFormView.vue?vue&type=template&id=98ffc17e&scoped=true&"
import script from "./PaymentFormView.vue?vue&type=script&lang=js&"
export * from "./PaymentFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ffc17e",
  null
  
)

export default component.exports